import {
  REPORTS_GET_APPOINTMENTS,
  REPORTS_SET_APPOINTMENTS,
  REPORTS_GET_FILTER_DATA,
  REPORTS_SET_FILTER_EMPLOYEE,
  REPORTS_SET_FILTER_START_DATE,
  REPORTS_SET_FILTER_END_DATE,
  REPORTS_SET_FILTER_STATUS,
  REPORTS_TOGGLE_CHANGE,
  REPORTS_ERROR_MESSAGE,
  REPORTS_HANDLE_REQUEST_CLOSE,
  REPORTS_SUCCESS_MESSAGE,
} from "../constants/ActionTypes";

export const reportsGetAppointments = payload => ({
  type: REPORTS_GET_APPOINTMENTS,
  payload,
});

export const reportsSetAppointments = payload => ({
  type: REPORTS_SET_APPOINTMENTS,
  payload,
});

export const reportsGetFilterData = payload => ({
  type: REPORTS_GET_FILTER_DATA,
  payload,
});

export const reportsSetFilterStartDate = payload => ({
  type: REPORTS_SET_FILTER_START_DATE,
  payload,
});

export const reportsSetFilterEndDate = payload => ({
  type: REPORTS_SET_FILTER_END_DATE,
  payload,
});

export const reportsSetFilterStatus = payload => ({
  type: REPORTS_SET_FILTER_STATUS,
  payload,
});

export const reportsSetFilterEmployee = payload => ({
  type: REPORTS_SET_FILTER_EMPLOYEE,
  payload,
});

export const reportsToggleChange = payload => ({
  type: REPORTS_TOGGLE_CHANGE,
  payload,
});

export const reportsErrorMessage = payload => ({
  type: REPORTS_ERROR_MESSAGE,
  payload,
});

export const reportsSuccessMessage = payload => ({
  type: REPORTS_SUCCESS_MESSAGE,
  payload,
});

export const reportsHandleRequestClose = payload => ({
  type: REPORTS_HANDLE_REQUEST_CLOSE,
  payload,
});



// WEBPACK FOOTER //
// ./actions/Reports.Action.js